module.exports = "/_next/static/images/img-about-hero-small-bf6aed29e2b638e276443267d466b42f.jpg";